export default {
  name: "Pricepoint",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 2C8.28 2 2 8.28 2 16s6.28 14 14 14 14-6.28 14-14S23.72 2 16 2zm0 26C9.38 28 4 22.62 4 16S9.38 4 16 4s12 5.38 12 12-5.38 12-12 12zm3.02-14.17c.12.54.64.88 1.19.77.54-.12.88-.65.77-1.19-.25-1.15-1.1-3-3.98-3.35V10c0-.55-.45-1-1-1s-1 .45-1 1v.06c-2.38.29-3.88 1.62-3.88 3.56 0 1.5 1.21 3.01 3.88 3.31v2.98c-1.49-.26-1.88-1.09-2.02-1.75-.12-.54-.65-.89-1.19-.77-.54.12-.88.65-.77 1.19.25 1.15 1.1 3 3.98 3.35V22c0 .55.45 1 1 1s1-.45 1-1v-.06c2.38-.29 3.88-1.62 3.88-3.56 0-1.78-1.52-3.04-3.88-3.32v-2.97c1.49.25 1.88 1.09 2.02 1.74zm-5.9-.21c0-1.02 1.03-1.39 1.88-1.54v2.83c-1.13-.17-1.88-.66-1.88-1.29zm5.76 4.76c0 1.02-1.03 1.39-1.88 1.54v-2.83c1.13.17 1.88.66 1.88 1.29z",
  },
}
